import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import studioService from '@pray/shared/services/studioService';
import type { CreditPlanOption } from '@pray/shared/services/studioService/credits';
import { mapCreditPlanOptions } from '@pray/shared/services/studioService/credits';

export function useCreditPlans(): UseQueryResult<CreditPlanOption[]> {
  async function fetchCreditPlans() {
    const response = await studioService.credits.getCreditPlans();
    return mapCreditPlanOptions(response.data);
  }

  const query = useQuery({
    staleTime: 1000 * 60 * 5, // 5 minutes
    queryKey: queryKeys.creditPlans(),
    queryFn: fetchCreditPlans,
  });

  return query;
}
